export default __webpack_public_path__ + "src/appV2/lib/Content/assets/images/cbh-logo-without-wordmark.png";